/** API route map: URLS.Controller.ReasonCodeSetup */
export const ReasonCodeSetup = {
      name: 'ReasonCode/',
      add: 'add',
      get: 'get',
      update: 'update',
      delete: 'delete',
      GetAllReasonCodes: 'get-all-reason-codes',
};
